module.exports = __webpack_public_path__ + "media/img/why/room-8d2dbbdb63c47b2a1151983b8cefc489.png";